import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import _ from 'lodash';

/**
* -ErrorList-
* ErrorList component
**/
class ErrorList extends React.Component {

	render() {
		return (
			<ul className="error-list">
				<CSSTransitionGroup
					transitionName="error-list"
					transitionEnterTimeout={ 1000 }
					transitionLeaveTimeout={ 1000 }
				>
					{ this.props.errors && this.props.errors.map((error, i) => <li key={ i } className="error">{ error }</li>) }
				</CSSTransitionGroup>
			</ul>
		)
	}
}

ErrorList.propTypes = {
	errors: PropTypes.array,
}

export default ErrorList;



// WEBPACK FOOTER //
// ./src/components/ErrorList.js